/* eslint-disable prettier/prettier */
import React from "react";
import PropTypes from "prop-types";

const Block = ({ color, value, hideText = false, valFormatter }) => {
  let cleanVal = value;
  if (valFormatter) {
    cleanVal = valFormatter(cleanVal);
  }
  return (
    <div className="legend-color__block-container">
      <div
        className="legend-color__block-swatch"
        style={{ backgroundColor: color }}
      />
      <div className="legend-color__block-text">
        {!hideText && <span>{cleanVal}+</span>}
      </div>
    </div>
  );
};

Block.defaultProps = {
  hideText: false,
  valFormatter: null,
}

Block.propTypes = {
  color: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hideText: PropTypes.bool,
  valFormatter: PropTypes.func,
};

export default Block;
